import {
  AsyncPipe,
  CommonModule,
  CurrencyPipe,
  DatePipe,
} from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerModule } from 'ngx-spinner';
import { VoucherService } from 'src/app/core/services/voucher.service';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { constants } from './config/constant';
import { DateTodayModule } from './core/common/datetoday/datetoday.module';
import { LoaderComponent } from './core/common/loader/loader.component';
import { NumpadModule } from './core/common/numpad/numpad.module';
import { PulseLoaderModule } from './core/common/pulse-loader/pulse-loader.module';
import { PulseLoaderService } from './core/common/pulse-loader/pulse-loader.service';
import { PhonePipe } from './core/pipe/phone.pipe';
import { ApiHttpService } from './core/services/apihttp.service';
import { BarcodeScannerModuleService } from './core/services/components/BarcodeScannerModule.service';
import { CPUModuleService } from './core/services/components/CPUModule.service';
import { IOModuleService } from './core/services/components/IOModule.service';
import { ReceiptPrinterModule } from './core/services/components/ReceiptPrinterModule.service';
import { BillAcceptorService } from './core/services/components/billacceptor.service';
import { BillDispenserService } from './core/services/components/billdispenser.service';
import { PinPadService } from './core/services/components/pinpad.service';
import { GamingService } from './core/services/gaming.service';
import { InterceptorService } from './core/services/interceptor.service';
import { LockdownService } from './core/services/lockdown.service';
import { LogService } from './core/services/log.service';
import { SignalrService } from './core/services/signalr.service';
import { StorageService } from './core/services/storage.service';
import { SuncashService } from './core/services/suncash.service';
import { KioskComponent } from './kiosk/kiosk.component';
import { OptionsModule } from './kiosk/options/options.module';
import { KeyboardService } from './core/common/keyboard/keyboard.service';
import { MagstripeReaderModuleService } from './core/services/components/MagstripeReader.service';

@NgModule({
  declarations: [AppComponent, KioskComponent, LoaderComponent,],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    NgxSpinnerModule,
    DateTodayModule,
    PulseLoaderModule,
    NumpadModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatDialogModule,
    NgbModule,
    OptionsModule,
  ],
  providers: [
    ApiHttpService,
    AsyncPipe,
    DatePipe,
    CurrencyPipe,
    PhonePipe,
    constants,
    LogService,
    StorageService,
    SignalrService,
    BillAcceptorService,
    BillDispenserService,
    IOModuleService,
    BarcodeScannerModuleService,
    ReceiptPrinterModule,
    CPUModuleService,
    MagstripeReaderModuleService,
    PinPadService,
    VoucherService,
    SuncashService,
    GamingService,
    PulseLoaderService,
    LockdownService,
    KeyboardService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule { }
